<template>
  <div class="shadeParent" style="padding: 5px">
    <Popup
      :anchor="'button'"
      :option="option"
      :show="show"
      :popup-class="'popup-content'"
      style="top: 16.5rem; left: 33rem"
    >
      <div class="container1">
        <div class="popup-header">
          <p style="color: white">{{ $t("popup.addShade") }}</p>
          <button class="close k-icon k-i-close" @click="show = false"></button>
        </div>

        <div class="body">
          <div class="shade-name">
            <p class="heading">{{ $t("popup.chooseYourColor") }}</p>
            <input
              class="shade"
              type="text"
              id="shade"
              :aria-label="$t('popup.enterSahdeName')"
              @input="$emit('input', handleEmit($event.target))"
            />
          </div>
          <div class="buttons">
            <input
              type="color"
              id="favcolor"
              name="favcolor"
              :aria-label="$t('popup.chooseYourColor')"
              :value="hexValue"
              @change="onInput($event)"
            />
          </div>
        </div>

        <div class="footer">
          <button
            type="submit"
            class="btn btn-secondary"
            @click="show = false"
            style="width: 70px; margin-right: 10px; border-radius: 4px; font-size: 0.9rem"
          >
            {{ $t("popup.close") }}
          </button>

          <button
            type="submit"
            class="btn btn-primary"
            @click="$emit('handleshadeAddition', option.name)"
            style="width: 150px; border-radius: 4px; font-size: 0.9rem"
          >
            {{ $t("popup.saveChanges") }}
          </button>
        </div>
      </div>
    </Popup>
    <button class="plusButton btn btn-primary" @click="show = true" ref="button"><i class="fas fa-plus"></i></button>
  </div>
</template>

<script lang="ts">
import { Popup } from "@progress/kendo-vue-popup";
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "PopupComp",
  components: {
    Popup
  },
  emits: ["input", "handleshadeAddition", "InputValue"],
  data(): any {
    return {
      show: false,
      hexValue: "#000000"
    };
  },
  props: {
    option: {
      type: Object as PropType<Record<string, any>>,
      default: () => ({})
    }
  },
  methods: {
    handleEmit(target: EventTarget | null) {
      this.$emit("InputValue", this.hexValue);
      return (target as HTMLInputElement).value;
    },
    onInput(event: any) {
      const newColor = event.target.value;
      this.hexValue = newColor;
      this.$emit("InputValue", newColor);
    }
  }
});
</script>

<style scoped>
body {
  font-family: Arial, Helvetica, sans-serif;
}
.btn-primary {
  background-color: #0054a6;
  color: white;
}
.plusButton {
  border-radius: 50% !important;
  width: 35px !important;
  height: 35px !important;
  font-size: large !important;
  position: absolute !important;
  left: 53rem !important;
  display: inline-flex !important;
  justify-content: center !important;
  align-items: center !important;
  background-color: #0054a6;
}
.body #favcolor:hover {
  cursor: pointer;
}
.container1 {
  height: 277px;
  width: 430px;
}
.popup-header {
  height: 51px;
  padding: 19px;
  display: flex;
  justify-content: space-between;
  background-color: #0054a6;
}
.body {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row-reverse;
  height: 10rem;
  border-top: 1px solid #dcdfe1;
  border-bottom: 1px solid #dcdfe1;
}
.heading {
  margin-top: -40px;
  margin-left: -81px;
  font-size: 15px;
  font-weight: bold;
  color: gray;
}
.body .shade {
  border-color: #dcdfe1;
  border-radius: 4px;
  width: 17rem;
  height: 32px;
  margin-left: 1rem;
}
.body #favcolor {
  height: 32px;
  width: 32px;
  margin-left: 1rem;
}
.footer {
  display: flex;
  justify-content: end;
  padding: 17px;
}
.btn {
  line-height: 1.5rem !important;
}
.k-i-close::before {
  color: white;
}
</style>
